module.exports = __webpack_public_path__ + "img/settings.c2d8d6df.png";